import apiClient from './client';
import { getUserId } from '../analytics';

/**
 * Get all stelline reward types for game-win CTA hints.
 */
export const getRewardTypes = async (token = null) => {
  const headers = {};
  const uid = getUserId();
  if (uid) headers['X-User-ID'] = uid;
  if (token) headers['Authorization'] = `Bearer ${token}`;

  const response = await apiClient.get(
    '/stelline/reward-types',
    { headers },
  );
  return response.data;
};
